import { render, staticRenderFns } from "./DisbursementList.vue?vue&type=template&id=206faccb&scoped=true&"
import script from "./DisbursementList.vue?vue&type=script&lang=js&"
export * from "./DisbursementList.vue?vue&type=script&lang=js&"
import style0 from "./DisbursementList.vue?vue&type=style&index=0&id=206faccb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206faccb",
  null
  
)

export default component.exports